export default "__VITE_ASSET__CbzIyPnH__"